module.exports = __webpack_public_path__ + "img/3_The Nature is in danger Felix Hehenberger und Alexander Feldinger.c7b59e91.jpg";